import React, { useEffect } from 'react';
import TemplateFormDumb from './TemplateFormDumb';
import { withRouter, useHistory } from 'react-router-dom';
import withRequest from 'hoc/withRequest';
import { useUser, useTemplate } from 'components/hooks';
import { TemplateSchema } from 'schemas';
import { Alert } from 'components/common';
import { ROUTES } from 'consts';
import { formatProjectItems, jobType, levelDetail, notificationType, pollingType } from 'helpers';


const TemplateCreateSmart = () => {
  const { parameters, setFilters, filters } = useUser();
  const history = useHistory();
  const { postTemplate, cleanUpMessage, error, success } = useTemplate();
  const projects = formatProjectItems(parameters);

  const defaultValues = {
    name: '',
    description: '',
    jobType: jobType[0].value,
    project: filters.project?parseInt(filters.project):0,
    inventory: '',
    credential: [],
    forks: 0,
    limit: 0,
    levelDetail: levelDetail[0].value,
    timeout: 0,
    commandLine: '',
    showChanges: false,
    consultExecution: false,
    enabledPrivileges: false,
    enabledJobs: false,
    useCache: false,
    additionalVariables: '',

    playbook: '',
    tagsJob: [],
    tagsSkip: [],
    tags: [],

    notificationType: notificationType[0].value,
    userProject: '',
    notifications: [],

    pollingType: pollingType[0].value,
    pollings: [],
  };

  const handleCloseAlert = () => cleanUpMessage();

  const handleCreate = (data) => {
    setFilters({ project: data.project });
    const template = new TemplateSchema();
    template.formatRequest(data);

    postTemplate({
      body: template.getValues(),
    });
  };

  useEffect(() => {
    if (!!success.post) history.push(ROUTES.TEMPLATE_LIST);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.post]);

  return (
    <>
      { projects && <TemplateFormDumb defaultValues={defaultValues} handleOnSubmit={handleCreate} />}
      <Alert severity="error" handleClose={handleCloseAlert} open={error.post} message="templateCreate.components.alert.error" />
    </>
  );
};

export default withRequest(withRouter(TemplateCreateSmart));
